<template>
  <div>
    <div class="card">
      <div class="bg-blue-light p-1">
        <TitleButton
            btnTitle="Register"
            :showBtn="false"
            :showAddNew="false"
            title="Employee Directory"
        />
      </div>

      <div class="my-2 px-2">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Job Status</label>
            <v-select
                placeholder="Select Job Status"
                v-model="employmentJobStatus"
                :options="jobStatusList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Employee Category</label>
            <v-select
                placeholder="Select Employee Category"
                v-model="employmentEmployeeCategory"
                :options="employeeCategoryList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Designation</label>
            <v-select
                placeholder="Select Designation"
                v-model="employmentDesignation"
                :options="designationList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Branch</label>
            <v-select
                placeholder="Select Branch"
                v-model="employmentBranch"
                :options="branchList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label class="col-form-label">Department</label>
            <v-select
                placeholder="Select Department"
                v-model="employmentDepartment"
                :options="departmentList"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
              <label class="col-form-label">Blood Group</label>
              <select class="form-control" id="gender" v-model="bloodGroup">
                <option value=''>Select Blood group</option>
                <option v-for="(blood, key) in bloodGroups" :value="key">{{ blood }}</option>
              </select>
          </div>
          <div class="col-12 col-sm-6 col-md-2 col-lg-2">
            <label class="col-form-label">Search</label>
            <input type="text" v-model="searchTerm" class="form-control" placeholder="Search ">
          </div>
          <div class="col-2 d-flex align-items-end">
            <button
                style="min-width: 64px;"
                @click="getContactsList"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Go
            </button>
          </div>
        </div>

        <div class="col-12" v-if="false">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="exportList"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Export
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mx-2" style="position: relative; z-index: 10;">
        <button
            class="btn btn-outline-primary btn-sm me-2 cursor-pointer"
            type="button"
            :class="{ active: viewMode === 'list' }"
            @click="setViewMode('list')"
        >
          <i class="fas fa-list"></i> List
        </button>
        <button
            class="btn btn-outline-primary btn-sm cursor-pointer"
            type="button"
            :class="{ active: viewMode === 'grid' }"
            @click="setViewMode('grid')"
        >
          <i class="fas fa-th"></i> Grid
        </button>
      </div>

      <div class="col-12 px-2 my-2 mb-3" v-if="viewMode === 'list'">
        <div class="card card-height mb-3">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Photo</th>
                <th class="nowrap">Full Name</th>
                <th class="nowrap">Designation</th>
                <th class="nowrap">Emp ID</th>
                <th class="nowrap">Department</th>
                <th class="nowrap">Branch</th>
                <th class="nowrap">Gender</th>
                <th class="nowrap">Email</th>
                <th class="nowrap">Mobile No</th>
                <th class="nowrap">Blood Group</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in contacts" :key="i">
                <td><img :src="item.photo" alt="Generic placeholder image" class="w-44"/></td>
                <td class="text-decoration-underline ">{{ item.full_name }}</td>
                <td>{{ item.employment_designation_name }}</td>
                <td>{{ item.serial_no }}</td>
                <td>{{ item.employment_department_name }}</td>
                <td>{{ item.employment_branch_name }}</td>
                <td class="text-capitalize">{{ item.gender }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.blood_group }}</td>
              </tr>
              </tbody>
            </table>
            <p v-if="!contacts.length" class="text-center mt-5">No data</p>
          </div>
        </div>
      </div>

      <div class="col-12 px-2 my-2 mb-3" v-if="viewMode === 'grid'">
        <div class="row g-4 mb-3">
          <div
              v-for="(item, i) in contacts"
              :key="i"
              class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
          >
            <div class="employee-card">
              <div class="text-center pt-1 d-flex flex-column justify-content-between">
                <div>
                  <div class="employee-photo">
                    <img
                        :src="item.photo"
                        alt="Profile"
                        class="img-fluid rounded-circle"
                    />
                  </div>
                  <h6 class="fw-semibold mt-1 mb-0 text-dark">{{ item.full_name }} ({{ item.serial_no }})</h6>
                  <h6 class="text-primary d-block">{{ item.employment_designation_name }}</h6>
                  <h6 class="d-block">{{ item.employment_department_name }}</h6>
                  <h6 class="d-block mb-1">{{ item.employment_branch_name }}</h6>
                </div>

                <div class="employee-info">
                  <p v-if="item.phone" class="mb-1 small">
                    <i class="fas fa-phone text-secondary"></i>
                    {{ item.phone }}
                  </p>
                  <p v-if="item.email" class="mb-1 small">
                    <i class="fas fa-envelope text-secondary"></i>
                    {{ item.email }}
                  </p>
                  <p v-if="item.gender" class="mb-1 small">
                    Gender: <span class="text-capitalize">{{ item.gender }}</span>
                  </p>
                  <p v-if="item.blood_group" class="mb-0 small">
                    Blood Group: {{ item.blood_group }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p v-if="!contacts.length" class="text-center mt-5">No data</p>
      </div>

      <div class="px-2 pt-2 my-2 position-absolute bottom-0">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
    </div>
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import {useRoute, useRouter} from "vue-router";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import Pagination from "@/components/atom/Pagination.vue";
import {useStore} from "vuex";
import handleRole from "@/services/modules/role";
import handleCompanyContact from "@/services/modules/companyContact";
import handleChartAccount from '@/services/modules/chartAccount'
import handleDropdowns from "@/services/modules/dropdowns";

const $route = useRoute();
const $router = useRouter();
const $store = useStore();

const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {fetchEmployeeList} = handleCompanyContact();
const {fetchCompanyDefaultRoles} = handleRole();
const { fetchHome } = handleChartAccount()
const { fetchDropdownList } = handleDropdowns()

const offset = ref(10);
const loading = ref(false);
const contacts = ref([])
const companyRules = ref([])
const employmentJobStatus = ref(null)
const employmentEmployeeCategory = ref(null)
const employmentBranch = ref(null)
const employmentDepartment = ref(null)
const bloodGroup = ref(null)
const employmentDesignation = ref(null)
const searchTerm = ref('');
let jobStatusList = ref([])
let employeeCategoryList = ref([])
let departmentList = ref([])
let branchList = ref([])
let designationList = ref([])
let bloodGroups = ref([])

// computed
const start = computed(() => $route.query.start);
const end = computed(() => $route.query.end);
const page = computed(() => $route.query.page);
const companyId = computed(() => $route.params.companyId);
const token = localStorage.getItem('token');

const viewMode = ref('list')
const setViewMode = (mode) => {
  viewMode.value = mode
}

//methods
const setPaginationData = (data) => {
  $store.commit('setPaginationData', data)
};
const resetPagination = () => {
  $store.commit('resetPagination')
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, $route.query)
  routeQuery.page = page
  await $router.push({path: $route.path, query: routeQuery})
  await getContactsList()
}
const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  if (page) query += '&page=' + page.value
  if (employmentJobStatus.value) query += '&employment_job_status=' + employmentJobStatus.value
  if (employmentEmployeeCategory.value) query += '&employment_employee_category=' + employmentEmployeeCategory.value
  if (employmentBranch.value) query += '&employment_branch=' + employmentBranch.value
  if (employmentDepartment.value) query += '&employment_department=' + employmentDepartment.value
  if (employmentDesignation.value) query += '&employment_designation=' + employmentDesignation.value
  if (bloodGroup.value) query += '&blood_group=' + bloodGroup.value
  if (searchTerm) query += '&q=' + searchTerm.value
  return query
};

async function getContactsList() {
  try {
    const res = await fetchEmployeeList(getQuery());
    if (!res.status) {
      contacts.value = [];
      return resetPagination()
    }
    contacts.value = res.data.data;
    await setPagination(res.data)
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  }
}

const exportList = () => {
  let objQuery = {
    company_id: $route.params.companyId,
    employment_job_status: employmentJobStatus.value ?? '',
    employment_employee_category: employmentEmployeeCategory.value ?? '',
    employment_branch: employmentBranch.value ?? '',
    employment_department: employmentDepartment.value ?? '',
    employment_designation: employmentDesignation.value ?? '',
    blood_group: bloodGroup.value ?? '',
    q: searchTerm.value ?? '',
    _token: token
  }
  let params = Object.entries(objQuery).map(([key, val]) => `${key}=${val}`).join('&');
  let url = `${process.env.VUE_APP_BASE_URL}/export/employees/?${params}`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}

const getDropdownList = async () => {
  let query = getQuery();
  query += '&is_branch=1&is_department=1&is_designation=1&is_employee_category=1&is_job_status=1'
  branchList.value = []
  departmentList.value = []
  designationList.value = []
  employeeCategoryList.value = []
  jobStatusList.value = []

  await fetchDropdownList(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data;
    branchList.value = data.branch_list;
    departmentList.value = data.department_list;
    designationList.value = data.designation_list;
    employeeCategoryList.value = data.employee_category_list;
    jobStatusList.value = data.job_status_list;
  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
  loading.value = true;
  const companyQuery = `?company_id=${companyId.value}`
  const rolesRes = fetchCompanyDefaultRoles(companyQuery)
  Promise.all([
    rolesRes.then(res => {
      if (res.data) companyRules.value = res.data
    }),
    fetchHome().then(res => {
      if (res.data) {
        bloodGroups.value = res.data.blood_groups
      }
    }),
    getContactsList(),
    getDropdownList()
  ]).then(() => {
    loading.value = false
  }).catch((err) => {
    loading.value = false
  })
})
</script>

<style scoped>
.btn-outline-primary.active {
  background-color: #7367f0 !important;
  color: white !important;
  border-color: #7367f0 !important;
}

.btn-outline-primary:hover {
  background-color: #7367f0;
  color: white;
  border-color: #7367f0;
}

.employee-card {
  border: none;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.employee-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.employee-photo img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 3px solid #e9ecef;
}

.employee-info i {
  color: #6c757d;
}

.employee-info p {
  margin: 0;
  line-height: 1.4;
}

</style>
